var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing"},[_c('img',{attrs:{"src":require("@/assets/images/nothing.png"),"alt":""}}),_c('p',[_vm._v("暂无信息")])])
}]

export { render, staticRenderFns }